import { Component } from '@angular/core';


@Component({
    templateUrl: './account-created.component.html',
    styleUrls: ['./account-created.component.scss'],
    standalone: true,
    imports: []
})
export class AccountCreatedComponent {

}
